import { createFileRoute } from '@tanstack/react-router';
import {
  ChartNoAxesColumnIncreasing,
  Copy,
  SignalHigh,
  Swords,
  X,
} from 'lucide-react';

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@/shared/components/ui/alert';
import { Avatar, AvatarFallback } from '@/shared/components/ui/avatar';
import { Button } from '@/shared/components/ui/button';

export const Route = createFileRoute('/internal/test-playalert')({
  component: TestPlayAlert,
});

function TestPlayAlert() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-8 p-4">
      <h1 className="text-xl font-bold">PlayAlert Component Test</h1>

      {/* With Mutual Servers (SignalHigh icon) */}
      <div className="w-full max-w-md">
        <p className="text-cold-400 mb-2 text-sm">With Mutual Servers:</p>
        <Alert variant="positive" className="relative">
          <Button
            variant="ghost"
            size="icon"
            className="text-cold-200 absolute top-2 right-2 size-5 hover:bg-white/10 hover:text-white"
            aria-label="Dismiss"
          >
            <X className="size-4" />
          </Button>

          <Swords className="size-4" />
          <AlertTitle>Looking to play?</AlertTitle>

          <AlertDescription className="mt-3 flex flex-col gap-1.5">
            <div className="-mx-4 mb-2 h-px bg-white/10" />

            <div className="flex items-center gap-3">
              <Avatar className="size-4">
                <AvatarFallback className="text-[8px]">Y</AvatarFallback>
              </Avatar>
              <span className="flex-1 truncate">YourName#TAG</span>
              <Button
                variant="ghost"
                size="sm"
                className="text-cold-400 hover:text-cold-200 h-auto gap-2 p-0"
              >
                <span>Copy</span>
                <Copy className="size-5" />
              </Button>
            </div>

            <div className="flex items-center gap-3">
              <Avatar className="size-4">
                <AvatarFallback className="text-[8px]">A</AvatarFallback>
              </Avatar>
              <span className="flex-1 truncate">Antony#1234</span>
              <Button
                variant="ghost"
                size="sm"
                className="text-cold-400 hover:text-cold-200 h-auto gap-2 p-0"
              >
                <span>Copy</span>
                <Copy className="size-5" />
              </Button>
            </div>

            {/* Mutual Servers with SignalHigh icon */}
            <div className="text-cold-500 mt-1 flex items-center gap-3">
              <SignalHigh className="size-4" />
              <span>Servers: London, Frankfurt</span>
            </div>
          </AlertDescription>
        </Alert>
      </div>

      {/* With Region fallback (ChartNoAxesColumnIncreasing icon) */}
      <div className="w-full max-w-md">
        <p className="text-cold-400 mb-2 text-sm">
          With Region Fallback (no servers):
        </p>
        <Alert variant="positive" className="relative">
          <Button
            variant="ghost"
            size="icon"
            className="text-cold-200 absolute top-2 right-2 size-5 hover:bg-white/10 hover:text-white"
            aria-label="Dismiss"
          >
            <X className="size-4" />
          </Button>

          <Swords className="size-4" />
          <AlertTitle>Looking to play?</AlertTitle>

          <AlertDescription className="mt-3 flex flex-col gap-1.5">
            <div className="-mx-4 mb-2 h-px bg-white/10" />

            <div className="flex items-center gap-3">
              <Avatar className="size-4">
                <AvatarFallback className="text-[8px]">Y</AvatarFallback>
              </Avatar>
              <span className="flex-1 truncate">YourName#TAG</span>
              <Button
                variant="ghost"
                size="sm"
                className="text-cold-400 hover:text-cold-200 h-auto gap-2 p-0"
              >
                <span>Copy</span>
                <Copy className="size-5" />
              </Button>
            </div>

            <div className="flex items-center gap-3">
              <Avatar className="size-4">
                <AvatarFallback className="text-[8px]">P</AvatarFallback>
              </Avatar>
              <span className="flex-1 truncate">Partner#5678</span>
              <Button
                variant="ghost"
                size="sm"
                className="text-cold-400 hover:text-cold-200 h-auto gap-2 p-0"
              >
                <span>Copy</span>
                <Copy className="size-5" />
              </Button>
            </div>

            {/* Region fallback with ChartNoAxesColumnIncreasing icon */}
            <div className="text-cold-500 mt-1 flex items-center gap-3">
              <ChartNoAxesColumnIncreasing className="size-4" />
              <span>Region: Europe</span>
            </div>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
}
